import React from 'react';
import { Container } from './styles';
import Search from '~/components/Search';

const RelatorioVendasPorDia: React.FC = () => {
  function defaultOnlyReport() {
    return false;
  }
  return (
    <Container>
      <Search
        codTela={299}
        onlyReport
        newData={defaultOnlyReport}
        onRowClick={defaultOnlyReport}
      />
    </Container>
  );
};

export default RelatorioVendasPorDia;
